module.exports = __webpack_public_path__ + "media/images/past_order_history/btn_Category_2_02-e2427e71ed5b5454c43d93b4a6e313ed.png";